import { render, staticRenderFns } from "./examenPies.vue?vue&type=template&id=5bdd469f"
import script from "./examenPies.vue?vue&type=script&lang=js"
export * from "./examenPies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports